import { OrderStatesEnum } from '../constants/order'
import { $adapteeAPI } from '../http'
import { IStation } from '../types/station'

export const DigibonAPI = {
    async fetchStations() {
        const { data } = await $adapteeAPI.get<{ data: IStation[] }>('digibon-stations')

        return data.data
    },
    async startOrderProcess(stationId: string, orderKey: string, orderState: OrderStatesEnum) {
        await $adapteeAPI.post('digibon-station-state', {
            station_id: stationId,
            order_token: orderKey,
            state: orderState,
        })
    },
    async updateOrderState(stationId: string, orderKey: string, orderState: OrderStatesEnum) {
        await $adapteeAPI.post('digibon-order-state', {
            station_id: stationId,
            order_token: orderKey,
            state: orderState,
        })
    },
    async updateProductQuantity(
        orderKey: string,
        stationCode: string,
        productId: string,
        quantity: number
    ) {
        await $adapteeAPI.post('order-product-state', {
            order_token: orderKey,
            kitchen_id: stationCode,
            product_id: productId,
            ready_quantity: quantity,
        })
    },
}
